import { useSelector } from "react-redux";

import { uiSelector } from "../../selectors/selectors";

export const useUIData = () => useSelector(uiSelector);
